import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import i18n from "../../locales/i18n";
import {
  getLdapGroups,
  getWorkOrder,
  getWorkOrderCategories,
  getWorkOrderComments,
} from "./workOrderApi";

type WorkOrderSla = {
  isExists: boolean;
  info: any[];
};

export interface IWorkOrderState {
  workOrder: any;
  workOrderStatus: {
    open: string;
    close: string;
    resolved: string;
  };
  workOrderFilterTitle: string;
  ldapGroups: any[];
  workOrderCategories: any[];
  workOrderComments: any[];
  columnVisibility: any;
  sla: WorkOrderSla;
}

const initialState: IWorkOrderState = {
  workOrder: "",
  workOrderStatus: {
    open: "",
    close: "",
    resolved: "",
  },
  workOrderFilterTitle: i18n.t("resources.workOrders.my_group_workorders"),
  ldapGroups: [],
  workOrderCategories: [],
  workOrderComments: [],
  sla: {
    isExists: false,
    info: [],
  },
  columnVisibility: localStorage.getItem("wocv")
    ? JSON.parse(localStorage.getItem("wocv") as any)
    : null,
};

export const workOrderSlice = createSlice({
  name: "workOrder",
  initialState,
  reducers: {
    setWorkOrderStatus: (state, action: PayloadAction<any>) => {
      action.payload.forEach((item: any) => {
        switch (item.name) {
          case "Açık":
            state.workOrderStatus["open"] = item.id;
            break;
          case "Kapatıldı":
            state.workOrderStatus["close"] = item.id;
            break;
          case "Çözümlendi":
            state.workOrderStatus["resolved"] = item.id;
            break;
        }
      });
    },
    setWorkOrder: (state, action: PayloadAction<any>) => {
      state.workOrder = action.payload;
    },
    setWorkOrderFilterTitle: (state, action: PayloadAction<any>) => {
      state.workOrderFilterTitle = action.payload;
    },
    setWorkOrderColumnVisibility: (state, action: PayloadAction<any>) => {
      state.columnVisibility = action.payload;
      localStorage.setItem("wocv", JSON.stringify(action.payload));
    },
    setWorkOrderSla: (state, action: PayloadAction<WorkOrderSla>) => {
      state.sla = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(getWorkOrder.matchFulfilled, (state, action) => {
      state.workOrder = action.payload.data;
    });
    builder.addMatcher(getLdapGroups.matchFulfilled, (state, action) => {
      state.ldapGroups = action.payload.data;
    });
    builder.addMatcher(
      getWorkOrderCategories.matchFulfilled,
      (state, action) => {
        state.workOrderCategories = action.payload.data;
      }
    );
    builder.addMatcher(getWorkOrderComments.matchFulfilled, (state, action) => {
      state.workOrderComments = action.payload.data;
    });
  },
});

// Action creators are generated for each case reducer function
export const {
  setWorkOrder,
  setWorkOrderStatus,
  setWorkOrderFilterTitle,
  setWorkOrderColumnVisibility,
  setWorkOrderSla,
} = workOrderSlice.actions;

export const selectWorkOrder = (state: RootState) => state.workOrder.workOrder;

export const selectWorkOrderStatus = (state: RootState) =>
  state.workOrder.workOrderStatus;

export const selectWorkOrderFilterTitle = (state: RootState) =>
  state.workOrder.workOrderFilterTitle;

export const selectLdapGroups = (state: RootState) =>
  state.workOrder.ldapGroups;

export const selectWorkOrderCategories = (state: RootState) =>
  state.workOrder.workOrderCategories;

export const selectWorkOrderComments = (state: RootState) =>
  state.workOrder.workOrderComments;

export const selectWorkOrderColumnVisibility = (state: RootState) =>
  state.workOrder.columnVisibility;

export const selectWorkOrderSla = (state: RootState) => state.workOrder.sla;

export default workOrderSlice.reducer;
